import classNames from "classnames";
import moment from "moment";
import React, { PropTypes } from "react";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedDate, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import simpleFetch from "../../../../../../../../utils/simpleFetch";
import * as dataActions from "../../../../../../../utils/data/dataActions";
import {
    DEPENDENT_COVERAGES,
    DEPENDENT_PERSON_SYNCS,
    DEPENDENTS,
    MEMBERS,
} from "../../../../../../../utils/data/models";
import { ArchiveButton, CheckboxButton, EditButton, Render } from "../../../../../../common";
import { DataTable } from "../../../../../../common/DataTable";
import { RectangleSpinner } from "../../../../../../common/spinners";
import { canViewSyncStatus, getLatestDependentSyncs, getOverlayForSync } from "../../../../../../common/synchronization/SynchronizationHelper";
import genders from "../../enums/genders";
import BasicDependentFields from "./BasicDependentFields";
import DependentsNav from "./DependentsNav";
import dependentRelations from "./enums/dependentRelations";
import dependentDisability from "./enums/dependentDisability";
import _ from "lodash";
import { toast } from "react-toastify";
import { GET_DATA_LIST_SUCCESS, UPDATE_DATA_ITEM_FAILURE } from "../../../../../../../utils/data/dataActionTypes";
import {
    ADMINISTRATOR,
    AGENT,
    DIRECTOR,
    FINANCE,
    FINTECH,
    HR_CLERK,
    MANAGER,
    PLAN_ADMINISTRATOR
} from "../../../../../../../utils/Roles";
import userHasAccess from "../../../../../../../utils/userHasAccess";
import { toLocaleDate } from "../../../../../../common/dateHelper";
import { toCamelCase } from "../../../../../../common/form/DBEnumStringHelper";
import { DEPENDENT_PERSON } from "../../../../../synchronization/enums/syncElementTypes";
import { MANUAL, RECURRING } from "../../../../enums/billingPeriodTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../../../enums/clientStatusTypes";
import { subProcessSyncType } from "../../../synchronizations/synchronizationTypes";

class DependentsDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            dependentSyncs: null,
            latestSyncs: null,
            allDependentCoverages: { items: [] },
        };

        this.archiveDependent = this.archiveDependent.bind(this);
        this.createDependent = this.createDependent.bind(this);
        this.toggleArchivedDependents = this.toggleArchivedDependents.bind(this);
        this.updateDependent = this.updateDependent.bind(this);
        this.getData = this.getData.bind(this);
        this.setCellClassNames = this.setCellClassNames.bind(this);
        this.getViewOnlyForClientStatusType = this.getViewOnlyForClientStatusType.bind(this);

        this.viewOnlyDependentForImplementation = !userHasAccess(FINANCE);
        this.viewOnlyDependentForActive = !userHasAccess([DIRECTOR, MANAGER, AGENT, PLAN_ADMINISTRATOR, ADMINISTRATOR, FINTECH, HR_CLERK], true);
        this.viewOnlyForTerminated = !userHasAccess(FINTECH);
        this.dependentsSynchronizations = this.dependentsSynchronizations.bind(this);
    }

    componentWillMount() {
        this.props.dataActions.clearDataList(DEPENDENTS);
    }

    getViewOnlyForClientStatusType() {
        const { clientStatusType, activeMember } = this.props;

        const isMemberArchived = activeMember && activeMember.isArchived && !userHasAccess(FINTECH);

        switch (clientStatusType) {
            case IMPLEMENTATION.value:
                return this.viewOnlyDependentForImplementation || isMemberArchived;
            case ACTIVE.value:
            case INACTIVE.value:
                return this.viewOnlyDependentForActive || isMemberArchived;
            case TERMINATED.value:
                return this.viewOnlyForTerminated || isMemberArchived;
        }
    }

    _cleanValues(values) {
        Object.entries(values).forEach(([key, value]) => {
            if (typeof value === "string") {
                values[key] = value.trim();
            }
        });
        delete values.dependentPersonPartnerHash;
        return {
            ...values,
            isSmoker: !`${values.isSmoker}`.trim() ? null : values.isSmoker,
            disabilityStartDate: values.isDisabled ? values.disabilityStartDate : null,
        };
    }

    archiveDependent(dependentPersonId, isArchived) {
        this.props.dataActions
            .updateDataItem(DEPENDENTS, {
                dependentPersonId,
                isArchived: !isArchived,
            })
            .then(() => {
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
                this.props.dataActions.getDataItem(MEMBERS, this.props.memberId, {
                    fields:
                        "memberCoverages(memberCoverageGuarantees(*),*),dependentPersons(*),beneficiaries(isArchived),*",
                });
                DependentsNav.getData(this.props.dataActions.getDataList, this.props.memberId);
            });
    }

    createDependent(values) {
        this.props.dataActions.createDataItem(DEPENDENTS, this._cleanValues(values)).then(() => {
            this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
            this.props.dataActions.getDataItem(MEMBERS, this.props.memberId, {
                fields:
                    "memberCoverages(memberCoverageGuarantees(*),*),dependentPersons(*),beneficiaries(isArchived),*",
            });
            DependentsNav.getData(this.props.dataActions.getDataList, this.props.memberId);
        });
    }

    createEmptyDependentModel(memberId) {
        return {
            birthdate: "",
            relationshipType: "",
            firstName: "",
            genderType: "",
            isSmoker: "",
            lastName: "",
            memberId,
            isDisabled: false
        };
    }

    setCellClassNames(dependent) {
        return classNames({
            archived: dependent.isArchived,
        });
    }

    toggleArchivedDependents() {
        const isArchivedFiltered = this.props.filters.includes(DEPENDENTS.archiveFilter);
        const filters = isArchivedFiltered
            ? this.props.filters.filter((filter) => filter != DEPENDENTS.archiveFilter)
            : [...this.props.filters, DEPENDENTS.archiveFilter];
        this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, filters);
    }

    updateDependent(values) {
        this.props.dataActions.updateDataItem(DEPENDENTS, this._cleanValues(values)).then((data) => {
            if (data.type === UPDATE_DATA_ITEM_FAILURE && toCamelCase(data.payload.error.data.error) == "invalidDisabilityStartDateError") {
                toast(<FormattedMessage id="dependents.errors.invalidDisabilityStartDateError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            }
            else {
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
                DependentsNav.getData(this.props.dataActions.getDataList, this.props.memberId);
            }
        });
    }

    getCols() {
        const { clientBillingPeriodType } = this.props;
        let cols = [
            {
                name: <FormattedMessage id="dependents.datatable.columns.name" />,
                sortKeys: ["firstName", "lastName"],
                display: (dependent) => (
                    <span
                        className={this.setCellClassNames(dependent)}
                    >{`${dependent.firstName} ${dependent.lastName}`}</span>
                ),
                widthPct: 22,
            },
            {
                name: <FormattedMessage id="dependents.datatable.columns.relation" />,
                key: "relationshipType",
                display: (dependent) => (
                    <span className={this.setCellClassNames(dependent)}>
                        <FormattedMessage
                            id={dependentRelations.find((relation) => relation.value == dependent.relationshipType).key}
                        />
                    </span>
                ),
                widthPct: 16,
            },
            {
                name: <FormattedMessage id="dependents.datatable.columns.gender" />,
                key: "genderType",
                display: (dependent) => (
                    <span className={this.setCellClassNames(dependent)}>
                        <FormattedMessage id={genders.find((gender) => gender.value == dependent.genderType).key} />
                    </span>
                ),
                widthPct: 12,
            },
            {
                name: <FormattedMessage id="dependents.datatable.columns.birthdate" />,
                key: "birthdate",
                display: (dependent) => (
                    <span className={this.setCellClassNames(dependent)}>
                        <FormattedDate
                            value={toLocaleDate(dependent.birthdate)}
                            year="numeric"
                            month="long"
                            day="2-digit"
                            timeZone="UTC"
                        />
                    </span>
                ),
                widthPct: 15,
            },
        ];
        if (clientBillingPeriodType == RECURRING.value) {
            cols.push({
                name: <FormattedMessage id="dependents.datatable.columns.disability" />,
                key: "isDisabled",
                display: (dependent) => (
                    <span className={this.setCellClassNames(dependent)}>
                        <FormattedMessage
                            id={
                                dependentDisability.find((disability) => disability.value == dependent.isDisabled).key
                            }
                        />
                    </span>
                ),
                widthPct: 8,
            });
        }
        if (canViewSyncStatus(this.props.activeClient, DEPENDENT_PERSON)) {
            cols.push({
                name: <FormattedMessage id="dependents.datatable.columns.sync" />,
                display: (dependent) => this.dependentsSynchronizations(dependent),
                widthPct: 6,
            });
        }
        cols.push({
            name: <FormattedMessage id="datatable.actions" />,
            display: (dependent) => this.generateActionButtons(dependent),
            widthPct: 20,
        });
        return cols;
    }

    dependentsSynchronizations(dependentPerson) {
        const { latestSyncs, allDependentCoverages } = this.state;
        if (!latestSyncs) {
            return <RectangleSpinner className="spinner-rect-col" />;
        }
        const latestDependentPersonSync = latestSyncs["dependentPersonSyncs"].find(
            (dependent) => dependent.dependentPersonId == dependentPerson.dependentPersonId
        );
        let memberCopy = _.cloneDeep(this.props.activeMember);
        let dependentPersonCopy = _.cloneDeep(dependentPerson);

        if (allDependentCoverages) {
            const dependentPersonCoverage = allDependentCoverages.items.filter(
                (coverage) => coverage.dependentPersonId === dependentPerson.dependentPersonId
            );

            const dependentCoverages = dependentPersonCoverage.map(coverage => _.omit(coverage, 'dependentPerson'));
            dependentPersonCopy.dependentCoverages = dependentCoverages;
        }
        memberCopy.memberCoverages = this.props.allMemberCoverages && this.props.allMemberCoverages.items;
        const data = { dependentPerson: dependentPersonCopy, member: memberCopy, client: this.props.activeClient };
        return getOverlayForSync(
            data,
            latestDependentPersonSync,
            "dependents.datatable",
            "dependentPersonPartnerHash",
            "dependentPersonHash",
            "dependentPerson"
        );
    }

    generateActionButtons(dependent) {
        const viewOnly = this.getViewOnlyForClientStatusType();

        return (
            <ButtonToolbar key={dependent.dependentPersonId}>
                <EditButton
                    title={<FormattedMessage id={`dependents.datatable.actions.${viewOnly ? "view" : "edit"}`} />}
                    label={<FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />}
                    form={BasicDependentFields}
                    props={{ disabled: viewOnly, clientBillingPeriodType: this.props.clientBillingPeriodType }}
                    allowSubmission={!viewOnly}
                    data={{
                        ...dependent,
                        birthdate: moment(new Date(dependent.birthdate).toISOString()),
                    }}
                    editFunction={this.updateDependent}
                />
                {!dependent.isArchived && (

                    <Render for={AGENT}>
                        <ArchiveButton
                            showDefaultDanger={true}
                            isArchived={dependent.isArchived}
                            disabled={viewOnly}
                            archivedName={`${dependent.firstName} ${dependent.lastName}`}
                            archiveFunction={this.archiveDependent.bind(
                                null,
                                dependent.dependentPersonId,
                                dependent.isArchived
                            )}
                            label={
                                dependent.isArchived ? (
                                    <FormattedMessage id="common.unarchive" />
                                ) : (
                                    <FormattedMessage id="common.archive" />
                                )
                            }
                        />
                    </Render>
                )}
            </ButtonToolbar>
        );
    }

    generateAddButton(memberId, canAddDependent) {
        return (
            <div>
                <CheckboxButton
                    className="include-archived"
                    id="archived"
                    label={<FormattedMessage id="dependents.datatable.actions.includeArchivedDependents" />}
                    checked={!this.props.filters.includes(DEPENDENTS.archiveFilter)}
                    onClick={this.toggleArchivedDependents}
                />
                {canAddDependent && (
                    <Render for={AGENT} exactly={[PLAN_ADMINISTRATOR, HR_CLERK]}>
                        <EditButton
                            title={<FormattedMessage id="dependents.datatable.actions.add" />}
                            label={<FormattedMessage id="common.add" />}
                            add={true}
                            form={BasicDependentFields}
                            data={this.createEmptyDependentModel(memberId)}
                            props={{ clientBillingPeriodType: this.props.clientBillingPeriodType }}
                            editFunction={this.createDependent}
                        />
                    </Render>
                )}
            </div>
        );
    }

    getData(offset, limit, q, sortBy, filters) {
        const isManualClient = this.props.clientBillingPeriodType === MANUAL.value;
        const hasAdminAccess = userHasAccess([ADMINISTRATOR, FINTECH], true);
        return this.props.dataActions
            .getDataList(DEPENDENTS, offset, limit, q, sortBy, filters, null, { memberId: this.props.memberId })
            .then((res) => {
                const dependentPersonIds = res.payload.data.items.map((d) => d.dependentPersonId);
                if (canViewSyncStatus(this.props.activeClient, DEPENDENT_PERSON)) {
                    getLatestDependentSyncs(this.props.clientId, dependentPersonIds, this.props.dataActions, (response) => {
                        const latestSyncs = response.payload.data;
                        this.setState({ latestSyncs });

                        if (dependentPersonIds && Array.isArray(dependentPersonIds) && dependentPersonIds.length > 0) {
                            const coverageFilter = [`dependentPersonCoverages.dependentPersonId=in=(${dependentPersonIds})`];
                            const coverageSort = ['dependentPersonId:desc'];
                            this.props.dataActions.getDataList(DEPENDENT_COVERAGES, 0, 0, null, coverageSort, coverageFilter).then((res) => {
                                if (res && res.type == GET_DATA_LIST_SUCCESS) {
                                    this.setState({ allDependentCoverages: res.payload.data });
                                } else {
                                    this.setState({ allDependentCoverages: { items: [] } });
                                }
                            });
                        }
                    }, true).catch(() => {
                        this.setState({ latestSyncs: [] });
                    });
                }
                if (isManualClient) {
                    const path = DEPENDENT_PERSON_SYNCS.path
                        .replace("{clientId}", this.props.clientId)
                        .replace("{memberId}", this.props.memberId);
                    hasAdminAccess &&
                        simpleFetch("GET", path, {
                            query: {
                                sortBy: ["dependentPersonId:desc", "createdAt:desc"],
                                filters: `subProcessSync.status==${subProcessSyncType.SUCCESS}`,
                            },
                        }).then((res) => {
                            if (res && res.length > 0) {
                                this.setState({ dependentSyncs: res });
                            } else {
                                this.setState({ dependentSyncs: [] });
                            }
                        });
                } else this.setState({ dependentSyncs: [] });
            });
    }

    render() {
        const canAddDependent = !this.getViewOnlyForClientStatusType();

        return (
            <DataTable
                ref="dataTable"
                title={<FormattedMessage id="dependents.title" />}
                getData={this.getData}
                cols={this.getCols()}
                q={this.props.q}
                filters={this.props.filters}
                offset={this.props.offset}
                data={this.props.items}
                rowsPerPage={this.props.limit}
                totalRows={this.props.total}
                sortBy={this.props.sortBy}
                addButton={this.generateAddButton(this.props.memberId, canAddDependent)}
                refreshFunction={this.getData}
            />
        );
    }
}

DependentsDataTable.propTypes = {
    dataActions: PropTypes.object,
    filters: PropTypes.array,
    q: PropTypes.string,
    items: PropTypes.array,
    limit: PropTypes.number,
    memberId: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    clientId: PropTypes.number,
    statuses: PropTypes.array,
    insuranceTypes: PropTypes.array,
    clientStatusType: PropTypes.string,
    clientBillingPeriodType: PropTypes.string,
    allMemberCoverages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    activeMember: PropTypes.object,
    activeClient: PropTypes.object
};

function mapStateToProps(state) {
    const data = state.data.dependents || {};
    const pagination = data.pagination || {};

    const activeMember = state.data.members.active;
    const activeMemberId = activeMember.memberId;
    const newMember = data.memberId != activeMemberId;
    const activeClient = state.data.clients.active;
    const allMemberCoverages = state.data.allMemberCoverages;

    return {
        memberId: activeMemberId,
        q: data.q,
        filters: newMember
            ? [
                `dependentPersons.memberId==${activeMemberId}`,
                DEPENDENTS.archiveFilter,
            ]
            : data.filters,
        limit: pagination.limit || 100,
        offset: pagination.offset || 0,
        sortBy: data.sortBy || ["firstName:asc", "lastName:asc"],
        total: pagination.totalCount || 0,
        items: data.items || null,
        clientStatusType: activeClient.clientStatusType,
        clientId: activeClient.clientId,
        clientBillingPeriodType: activeClient.clientBillingPeriodType,
        activeMember,
        activeClient,
        allMemberCoverages,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DependentsDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/DependentsDataTable.js